import React from 'react';
import { observer } from 'mobx-react-lite';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import debounce from 'lodash/debounce';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import { useRootStore } from '../../../../mobx/bridge';
import styles from './SearchBar.module.css';

const LoadbarStyle = makeStyles({
  root: {
    margin: '0 8px -4px 8px',
    zIndex: '1',
    borderRadius: '18px 18px 0 0',
  },
  barColorPrimary: {
    backgroundColor: '#0ab4e5',
  },
  colorPrimary: {
    backgroundColor: 'transparent',
  },
});

// eslint-disable-next-line prefer-arrow-callback,sonarjs/cognitive-complexity
const SearchBar = observer(function SearchBar() {
  const { commonStore, sendingEvents } = useRootStore();
  const [searchInput, setSearchInput] = React.useState('');

  const { t } = useTranslation();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getSearchResults = React.useCallback(
    debounce(() => {
      commonStore.setChannelSearchInput(searchInput);

      let phoneNumberInput = '';
      const sanitizedInput = commonStore.channelSearchInput.replace(/[^\d]/g, '')?.trim();

      if (/^\d+$/.test(sanitizedInput)) {
        phoneNumberInput = sanitizedInput;
      }

      if (phoneNumberInput || commonStore.channelSearchInput?.trim()) {
        commonStore.setIsFetchingSearchResults(true);
        commonStore.setIsLoadingSearchResultData(true);

        sendingEvents.socketEmitGetSearchResult(
          250,
          phoneNumberInput || commonStore.channelSearchInput,
          commonStore.contactTypeIdsToSearch
        );
      }
    }, 500),
    [searchInput]
  );

  React.useEffect(() => {
    if (searchInput?.trim()) {
      getSearchResults();
    } else {
      commonStore.setChannelSearchInput('');
      commonStore.setSearchResultData([]);
    }

    return () => {
      getSearchResults.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchInput]);

  const onSuggestionsFetchRequested = (e) => {
    setSearchInput(e.target.value);
  };

  const loadBarClass = LoadbarStyle();

  return (
    <Grid component="div" container className={styles.searchbarMain}>
      <Grid component="div" item xs={12}>
        {commonStore.isLoadingSearchResultData ? (
          <LinearProgress key={0} classes={loadBarClass} />
        ) : null}

        <input
          type="search"
          id="leftSideSearchBar"
          value={searchInput}
          onChange={onSuggestionsFetchRequested}
          maxLength={100}
          placeholder={t('Searchbar.SearchPlaceholder')}
          data-testid="leftSideSearchBarTestId"
        />
      </Grid>
    </Grid>
  );
});
SearchBar.whyDidYouRender = true;
SearchBar.displayName = 'SearchBar';

export default SearchBar;
